module.exports = {"pathContext":{"slug":"/it/ddbd/","langKey":"it"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/it-ddbd.json
// module id = 1578
// module chunks = 168648818355148